import { Theme, ToggleButton, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import MultipleSelectionIcon from 'components/icons/MultipleSelectionIcons/MultipleSelectionIcon';
import { useEffect } from 'react';
import { getStyleVariables } from 'styles/vars';
import { useTracker } from '../../Tracker/TrackerProvider';
import { PDFTronTools } from 'types';

const useStyles = makeStyles()((theme: Theme) => {
  const styleVars = getStyleVariables(theme);
  return {
    toggleButton: {
      borderRadius: '50%',
      width: '24px',
      height: '24px',
      padding: 0,
      margin: theme.spacing(0.25),
      color: 'rgba(255,255,255,.7)',
      border: 'none',
      '&:hover': {
        color: 'rgba(255,255,255)',
        backgroundColor: 'rgba(255,255,255,.04)',
      },
      '&.Mui-selected': {
        backgroundColor: styleVars.colors.red,
      },
      '&.Mui-selected:hover': {
        backgroundColor: styleVars.colors.red,
      },
      '&.Mui-disabled': {
        color: 'rgba(255,255,255,.37) !important',
      },
    },
    icon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      cursor: 'pointer',
    },
    disabled: {
      color: 'rgba(255,255,255,.37) !important',
    },
  };
});

interface BulkActionToggleProps {
  disabled: boolean;
  handleSetMultipleSelectionMode: (mode: boolean) => void;
  multipleSelectionMode: boolean;
  selectedTool?: string;
}

const BulkActionToggle = ({
  disabled,
  handleSetMultipleSelectionMode,
  multipleSelectionMode,
  selectedTool,
}: BulkActionToggleProps) => {
  const { classes } = useStyles();
  const tracker = useTracker();

  // Turn off multiple selection mode when there are no results
  useEffect(() => {
    if (disabled && multipleSelectionMode) {
      handleSetMultipleSelectionMode(false);
    }
  }, [disabled, multipleSelectionMode, handleSetMultipleSelectionMode]);

  const handleToggleClick = () => {
    const newMode = !multipleSelectionMode;
    handleSetMultipleSelectionMode(newMode);

    // Track the select multiple results button click
    tracker.track({
      name: 'bulk-action-select-multiple-results-clicked',
      data: {
        enabled: newMode,
      },
    });
  };

  return (
    <>
      <Tooltip
        title={
          disabled && selectedTool === PDFTronTools.RESYNC ? (
            <div style={{ whiteSpace: 'pre-line', textAlign: 'center' }}>
              Turn off re-inspect to{'\n'}enable multi-select
            </div>
          ) : (
            'Select multiple results'
          )
        }
        placement="bottom"
      >
        <span>
          <ToggleButton
            value="multipleSelectionButton"
            selected={multipleSelectionMode}
            className={classes.toggleButton}
            onClick={handleToggleClick}
            disabled={disabled}
            classes={{ disabled: classes.disabled }}
            disableRipple
          >
            <MultipleSelectionIcon className={classes.icon} />
          </ToggleButton>
        </span>
      </Tooltip>
    </>
  );
};

export default BulkActionToggle;
